<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file card-basic.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  card-basic.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: card-basic 
 Created by keni.
 with: IntelliJ IDEA
 Date: 27/04/2018
 Time: 13:14
------------------------------------------------------------------------------->
<template>
    <div class="card">
        <img v-if="image_content !== null && img.src != null"
             class="card-img-top" src="" alt="Card image cap">
        <div class="card-body">
            <component :is="title_elm" :class="title_class">
                <slot name="title"></slot>
            </component>
            <div class="card-text">
                <slot name="summary"></slot>
            </div>
        </div>
        <slot name="main"></slot>
        <div v-if="display && display.footer_content!=''" class="card-body">
            <a href="#" class="card-link">Card link</a>
            <a href="#" class="card-link">Another link</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "card-basic",
        components: {},
        /*
         display:{
         title:true,
         image:false,
         title_content:false,
         footer:false
         }
         */
        props: {
            display: {
                type: Object || Function,
                default: null
            },
            title_class: {
                type: String,
                default: 'd-flex justify-content-between align-items-center'
            },
            title_elm: {
                type: String,
                default: 'h5'
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            if (this.display !== null) {
                if (this.display.hasOwnProperty('image_content')) {
                    this.image_content = ( this.display.image_content !== null)? this.display.image_content:null;
                }
            }
        },
        data() {
            return {
                show_image: false,
                img: {
                    src: null
                },
                image_content: null

            }
        },
        methods: {},
        watch: {
            display() {
            }
        },
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/cards/CardBasic.vue